import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ComponentFactoryResolver, Injector } from '@angular/core';
import { BaseEntity } from '../../models/baseEntity';
import { DatePipe } from '@angular/common';
import { DatatableComponent, TableColumn } from '@swimlane/ngx-datatable';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { TemplateComponent } from '../_entities/templatte';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'lean-table',
  templateUrl: './lean-table.component.html',
  styleUrls: ['./lean-table.component.scss']
})
export class LeanTableComponent implements OnInit {

  @ViewChild('table', {static: false}) table: DatatableComponent;
  @ViewChild('pager', {static: false}) pager;
  
  //SelectionType = SelectionType;

  @Input() title            : string;
  @Input() columns          : any[];  
  @Input() rows             : BaseEntity[]  = [];
  @Input() editRowByRow     : boolean       = false;
  @Input() editAllRows      : boolean       = false;     // All rows considered in edit mode
  @Input() enableNew        : boolean       = false;
  @Input() enableExport     : boolean       = false;
  @Input() pageSize         : number        =  this.configService.config.pageSize;
  @Input() footerHeight     : number        = 50;
  @Input() columnMode       : string        ='force'; 
  @Input() addNewLabel      : string        = 'Ajouter Nouveau';
  @Input() action1Icon      : string;
  @Input() action2Icon      : string;
  @Input() action3Icon      : string;
  @Input() action4Icon      : string;
  @Input() action5Icon      : string;


  @Output() onNew         = new EventEmitter<BaseEntity>();
  @Output() onSave        = new EventEmitter<BaseEntity>();
  @Output() onSort        = new EventEmitter<string>();
  @Output() onSelect      = new EventEmitter<BaseEntity>();
  @Output() onAction1     = new EventEmitter<BaseEntity>();
  @Output() onAction2     = new EventEmitter<BaseEntity>();
  @Output() onAction3     = new EventEmitter<BaseEntity>();
  @Output() onAction4     = new EventEmitter<BaseEntity>();
  @Output() onAction5     = new EventEmitter<BaseEntity>();
  @Output() onPreviousPage= new EventEmitter<any>();
//----------------------------------------------------------------
  @Input() totalRowCount    : number = -1;
  @Input() serverPageNumber : number;
  @Input() serverPageCount  : number;
  @Output() onNextPage      = new EventEmitter<any>();

//----------------------------------------------------------------

  datePipe = new DatePipe('en-US');
  
  constructor(
        private dialog                  : MatDialog,
        private componentFactoryResolver: ComponentFactoryResolver,
        public configService            : ConfigService,
        private injector                : Injector
    ) { }

  ngOnInit() {
  }

  sort(event){
    this.onSort.emit(event.column.prop);
  }

  selectRow(event :  any){
    if (event.selected) {
      this.onSelect.emit(event.selected[0]);
    }
  }

  new(row : BaseEntity){
    row.inserted  = true;
    this.onNew.emit(row);
  }

  addNew(){
    this.goToLastPage();
    this.onNew.emit(null);
  }

  edit(entity : BaseEntity) {
    entity._original  = { ...entity };
    entity.edit       = true;
    entity.updated    = true;
  }

  cancelChanges(entity : BaseEntity) {
      this.rows[this.rows.indexOf(entity)] = entity._original;
      entity.edit    = false;
      entity.updated = false;
      this.rows = [...this.rows];
  }
  
  save(entity : BaseEntity){
    this.onSave.emit(entity);
  }


  editable(row : BaseEntity) : boolean {
    if (this.editAllRows) return true;
    return row.edit;
  }


//---------------------------------------------------------------------------------------------------------
  nextPage(){
    this.onNextPage.emit(null);
  }
  previousPage(){
    this.onPreviousPage.emit(null);
  }
//---------------------------------------------------------------------------------------------------------
  

  //---------------------------------------------------------------------------------------------------------
  getJsonProp(row, column) {

    if (!row) {
      return '';
    }

    if (column.lov){
      let value = null;
      let keyValue = null;
      
      if (column.key){
        keyValue = row[column.prop][column.key];
      } else {
        keyValue = row[column.prop];
      }

      for (let d of column.lov.data){
        if (d[column.lov.key] == keyValue){
          value = d[column.lov.value];
          break;
        }
      }
      return value;
    }

     let props = column.prop;
      const args = props.split('.');
      let cur = row;
      for(let i=0;i<args.length;i++){
          cur = cur[args[i]];
          if (! cur){
            break;
          }
      }

      if (column.type == 'date'){
        cur = this.datePipe.transform(cur, 'dd/MM/yyyy');
      }
      if (column.type == 'time'){
        cur = this.datePipe.transform(cur, 'HH:mm');
      }
      if (column.type == 'dateTime'){
        cur = this.datePipe.transform(cur, 'dd/MM/yyyy HH:mm');
      }

      if ( cur && (column.modal) && (column.subProp) ){
        cur = cur[column.subProp];
      }
  
      return cur;
    }
  
  getRowClass(row : BaseEntity, column : any){
    let cls = '';

    if (! row) return cls;
    
    if (row.deleted) {
      cls = 'deleted-row ';
    }

    if (column){
      cls += column.class;
    }
    return cls;
  } 

  getStyle(column : any){
    let stl = '';

    if (column.style){
      stl = column.style;
    }
    return stl;
  } 

//---------------------------------------------------------------------------------------------
  showColumnModal(row : BaseEntity, column : any){  

    const fieldName = column.prop.split('.')[0];
    let dialogRef   : any;

    if (column.modalParam) {
     
      dialogRef = this.dialog.open(column.modal,  {autoFocus : false, hasBackdrop : false, data : {param : column.modalParam}});
    } else {
      dialogRef = this.dialog.open(column.modal);
    }

    dialogRef.afterClosed().subscribe(selectedRow => {
      if(selectedRow){
        row[fieldName] = selectedRow;
      }
    });

  }
//---------------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------------
   getModalValue(column, value)  : string{
    if (column.subProp) return value[column.subProp]
    return value;
   }
//---------------------------------------------------------------------------------------------


  //-------------------------------------------------------------------------------------------
  getLovValue(column, value)  : string{
    let result : string = "---";
    let val = value;
    if (column.key) {
      val = value[column.key];
    }  
    for(let item of column.lov.data) {
      if (item[column.lov.key] == val) {
        result = item[column.lov.value]; 
        console.log(result);
        break;
      } 
    }
    return result;
  }
//-------------------------------------------------------------------------------------------
  

 //---------------------------------------------------------------------------------------------
 imgLabel: string = "Choose file...";
  setImage(row: BaseEntity, column, input : HTMLInputElement) {
    let files: FileList = input.files
      this.getBase64(files[0]).then( result =>{
        row[column.prop] = result;
        input.value = "";
      });
  }

  getBase64(file): Promise<any> {
      return new Promise((resolve, reject) => {
          const reader = new FileReader(); // to read the content of the file asynchronously !
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
      });
  }
 //---------------------------------------------------------------------------------------------


 //---------------------------------------------------------------------------------------------
  action1(row : any) {
    this.onAction1.emit(row);
  }
  action2(row : any) {
    this.onAction2.emit(row);
  }
  action3(row : any) {
    this.onAction3.emit(row);
  }
  action4(row : any) {
    this.onAction4.emit(row);
  }
  action5(row : any) {
    this.onAction5.emit(row);
  }
 //---------------------------------------------------------------------------------------------



 //---------------------------------------------------------------------------------------------

  exportAsCSV(){
    this.exportAsCSV2(this.table, this.componentFactoryResolver, this.injector)
  }

  exportAsCSV2(dataTable: DatatableComponent, resolver: ComponentFactoryResolver, injector: Injector) {
      const columns: TableColumn[] = dataTable.columns || dataTable._internalColumns;
      const headers =
          columns
              .map((column: TableColumn) => column.name)
              .filter((e) => e);  // remove column without name (i.e. falsy value)
  
      const rows: any[] = dataTable.rows.map((row) => {
          let r = {};
  
          columns.forEach((column) => {
              if (!column.name) { return; }   // ignore column without name
  
              var prop
              var propValue;
              if (column.prop) {
                  prop = column.prop.toString();
                  propValue = this.getNestedPropertyValue(row, prop);
              }
  
              if (column.cellTemplate) {
                  r[column.name] = this.getRenderedTemplateText(column.cellTemplate, propValue, row, resolver, injector);
              } else {
                let value = propValue;
                if (typeof propValue === 'boolean') {
                  value = propValue ? 'Yes' : 'No';
                } 
                let xx= column as any;
                if (xx.type == "datetime"){
                  value =  this.datePipe.transform(propValue, 'dd/MM/yyyy HH:mm');
                }
                if (xx.type == "date"){
                  value =  this.datePipe.transform(propValue, 'dd/MM/yyyy');
                }

                r[column.name] = value;
         //         r[column.name] = (typeof propValue === 'boolean') ? (propValue ? 'Yes' : 'No') : propValue;
              }
          });
  
          return r;
      });
  
      const options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          headers: headers,
          showTitle: false,
          title: 'Lean Data Export',
          useBom: true
      };
  
      return new Angular5Csv(rows, 'LeanDataExport', options);
  }
//---------------------------------------------------------------------------------------------

  
   getRenderedTemplateText(template, value, row, resolver: ComponentFactoryResolver, injector: Injector) {
      const factory = resolver.resolveComponentFactory(TemplateComponent);
      const component = factory.create(injector);
  
      component.instance.template = template;
      component.instance.context = { value: value, row: row };
      component.changeDetectorRef.detectChanges();
  
      return component.location.nativeElement.textContent.trim();
  }
  
  getNestedPropertyValue(object: any, nestedPropertyName: string) {
      var dotIndex = nestedPropertyName.indexOf(".");
      if (dotIndex == -1) {
          return object[nestedPropertyName];
      } else {
          var propertyName = nestedPropertyName.substring(0, dotIndex);
          var nestedPropertyNames = nestedPropertyName.substring(dotIndex + 1);
  
          return this.getNestedPropertyValue(object[propertyName], nestedPropertyNames);
      }
  }

  goToLastPage(){
    if (this.pager) {
      this.table.offset=Math.ceil(this.pager._count/this.pager._size)-1;
    }
  }

}
